export enum VendorPopupTab {
  VendorDetails = 'details',
  Quotation = 'quotation',
  Remarks = 'remarks',
}
